import { useState, useEffect, useCallback } from 'react';

const KEY_COLLAPSED = 'sireppar_sidebar_collapsed';
const KEY_OPEN_GROUPS = 'sireppar_sidebar_open_groups';

export function useSidebarState() {
  const [collapsed, setCollapsed] = useState<boolean>(() => {
    return localStorage.getItem(KEY_COLLAPSED) === 'true';
  });

  const [openGroups, setOpenGroups] = useState<string[]>(() => {
    try {
      const stored = localStorage.getItem(KEY_OPEN_GROUPS);
      return stored ? JSON.parse(stored) : [];
    } catch {
      return [];
    }
  });

  const toggleCollapsed = useCallback(() => {
    setCollapsed(prev => {
      const next = !prev;
      localStorage.setItem(KEY_COLLAPSED, String(next));
      return next;
    });
  }, []);

  const toggleGroup = useCallback((id: string) => {
    setOpenGroups(prev => {
      const next = prev.includes(id) ? prev.filter(g => g !== id) : [...prev, id];
      localStorage.setItem(KEY_OPEN_GROUPS, JSON.stringify(next));
      return next;
    });
  }, []);

  const openGroup = useCallback((id: string) => {
    setOpenGroups(prev => {
      if (prev.includes(id)) return prev;
      const next = [...prev, id];
      localStorage.setItem(KEY_OPEN_GROUPS, JSON.stringify(next));
      return next;
    });
  }, []);

  useEffect(() => {
    const handler = (e: KeyboardEvent) => {
      if (e.ctrlKey && e.key === 'b') {
        e.preventDefault();
        toggleCollapsed();
      }
    };
    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, [toggleCollapsed]);

  return { collapsed, toggleCollapsed, openGroups, toggleGroup, openGroup };
}
